export const dateTypes = {
  date: 'YYYY-MM-DD',
  dateTime: 'YYYY-MM-DD HH:mm:ss',
  dateTimeISO: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
  dateBR: 'DD/MM/YYYY',
  dateShortBR: 'DD/MM/YY',
  dateTimeBR: 'DD/MM/YYYY HH:mm:ss',
  dateUS: 'MM/DD/YYYY',
  dateShortUS: 'MM/DD/YY',
  dateTimeUS: 'MM/DD/YYYY HH:mm:ss',
  time: 'HH:mm:ss',
  startDate: 'YYYY-MM-DDT00:00:00.000Z',
  endDate: 'YYYY-MM-DDT23:59:59.000Z',
  allTimeInit: '1999-01-01T00:00:00.000Z',
  hourMinute: 'HH:mm'
}
